import React from 'react'

import { Image } from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import config from 'config'

const { assets_url: assetsUrl } = config

const MaintenancePage = () => (
  <div className="campus-maintenance">
    <div className="campus-maintenance__content">
      <Image src="/assets/img/maintenance/campus-logo.svg" />

      <picture className="campus-maintenance__cone">
        <source
          srcSet={`${assetsUrl}/assets/img/maintenance/cone-lg/group.png`}
          media="(min-width: 600px)"
          alt="Quipper Campus sedang dalam perbaikan"
        />
        <img
          src={`${assetsUrl}/assets/img/maintenance/cone-sm/group.png`}
          alt="Quipper Campus sedang dalam perbaikan"
        />
      </picture>

      <Typography className="campus-maintenance__headline text-center" variant="headline">
        Mohon maaf, kami sedang dalam perbaikan!
      </Typography>
      <Typography component="a" href="/" className="campus-maintenance__message text-center" variant="body">
        Kembali ke beranda
      </Typography>
    </div>
    <style jsx>
      {`
        .campus-maintenance {
          background-color: #f6f7fa;
          width: 100vw;
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          &__content {
            display: flex;
            flex-direction: column;
          }
          :global(&__headline) {
            font-weight: bold;
            margin-bottom: 16px !important;
          }
          &__cone {
            margin-top: 48px;
            margin-bottom: 24px;
            text-align: center;
          }
        }
      `}
    </style>
  </div>
)

export default MaintenancePage
